import StepTwoImage from 'assets/images/about-us/adult-taking-care-their-hair.jpg';
import StepOneImage from 'assets/images/about-us/young-woman-applying-anti-dandruff-product.jpg';
import Image from 'components/image';
import React from 'react';
import { genImageAltText } from 'utils/genImageAltText';

export const HowToUseProduct: React.FC = () => {
  return (
    <div className='w-full space-y-6 border-l-2 border-hl-beige pl-6 mt-4 mx-auto lg:mt-8 lg:max-w-3xl'>
      <div className='relative before:content-["1"] before:absolute before:-left-11 before:top-2 before:w-10 before:h-10 before:rounded-full before:bg-hl-black before:text-white before:flex before:justify-center before:items-center before:align-middle'>
        <div className='space-y-2 pl-4'>
          <p className='text-lg text-justify font-medium'>Giữ sản phẩm khoảng 20-30cm ra xa tóc và xịt đều lên toàn bộ mái tóc từ gốc đến ngọn.</p>
          <Image src={StepOneImage} alt={genImageAltText('Giữ sản phẩm khoảng 20-30cm ra xa tóc và xịt đều lên toàn bộ mái tóc từ gốc đến ngọn')} />
        </div>
      </div>

      <div className='relative before:content-["2"] before:absolute before:-left-11 before:top-2 before:w-10 before:h-10 before:rounded-full before:bg-hl-black before:text-white before:flex before:justify-center before:items-center before:align-middle'>
        <div className='space-y-2 pl-4'>
          <p className='text-lg text-justify font-medium'>
            Sử dụng ngón tay hoặc lược để vuốc hoặc chải đều sản phẩm từ gốc đến ngọn, đảm bảo phân phối đều và hấp thụ vào tóc.
          </p>
          <Image
            src={StepTwoImage}
            alt={genImageAltText(
              'Sử dụng ngón tay hoặc lược để vuốc hoặc chải đều sản phẩm từ gốc đến ngọn, đảm bảo phân phối đều và hấp thụ vào tóc'
            )}
          />
        </div>
      </div>
    </div>
  );
};
